import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-100 rounded-t-2xl mx-2 md:mx-4 mt-16 md:mt-20">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                51
              </span>
              <span className="font-heading font-bold text-xl text-background-50">
                吃瓜
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              聚合全网最新黑料吃瓜，速递今日大瓜全纪录，直击网红明星塌房现场。独家资源集散第一站，实时追踪不间断。
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  网站首页
                </Link>
              </li>
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold text-background-50 mb-4">关注我们</h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a href="#" rel="nofollow noreferrer" className="flex items-center gap-2 text-sm text-background-400 hover:text-primary-400 transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line" /></span>
                  新浪微博
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow noreferrer" className="flex items-center gap-2 text-sm text-background-400 hover:text-primary-400 transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line" /></span>
                  微信公众号
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow noreferrer" className="flex items-center gap-2 text-sm text-background-400 hover:text-primary-400 transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-article-line" /></span>
                  今日头条
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow noreferrer" className="flex items-center gap-2 text-sm text-background-400 hover:text-primary-400 transition-colors">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-video-line" /></span>
                  抖音号
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold text-background-50 mb-2">订阅推送</h3>
            <p className="text-sm text-background-400 mb-3">第一时间获取最新黑料大瓜</p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱地址"
                className="flex-1 px-3 py-2.5 rounded-lg bg-foreground-900 border border-foreground-800 text-background-50 text-sm placeholder:text-background-600 focus:outline-none focus:border-primary-500"
              />
              <button
                type="submit"
                className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-background-50 text-foreground-950 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="订阅"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </form>
            {subscribed && (
              <p className="text-xs text-primary-400 mt-2">订阅成功！感谢关注51吃瓜</p>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-900">
          <p className="font-heading text-4xl md:text-6xl font-bold text-foreground-900 select-none">
            51吃瓜
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mt-4 gap-2">
            <p className="text-xs text-background-600">
              &copy; 2026 51吃瓜网站 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-background-600">
              <a href="#" className="hover:text-background-400 transition-colors">免责声明</a>
              <a href="#" className="hover:text-background-400 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-background-400 transition-colors">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}